// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Erc712 from "./Erc712.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as ContractUtil from "./ContractUtil.bs.js";

function createPermitSig(provider, verifyingContract, nonce, chainId, holder, spender) {
  var domain_salt = "0x" + chainId.toString(16).padStart(64, "0");
  var domain = {
    name: "(PoS) Dai Stablecoin",
    version: "1",
    verifyingContract: verifyingContract,
    salt: domain_salt
  };
  var message = {
    holder: holder,
    spender: spender,
    nonce: nonce,
    expiry: 0,
    allowed: true
  };
  var data = {
    types: {
      EIP712Domain: Erc712.eip712Domain,
      Permit: Erc712.permit
    },
    domain: domain,
    primaryType: "Permit",
    message: message
  };
  var dataString = Belt_Option.getWithDefault(JSON.stringify(data), "");
  var exampleRpcDefinition_params = [
    holder,
    dataString
  ];
  var exampleRpcDefinition = {
    method: "eth_signTypedData_v3",
    params: exampleRpcDefinition_params,
    from: holder
  };
  return new Promise((function (resolve, reject) {
                provider.sendAsync(exampleRpcDefinition, (function (err, result) {
                        if (err == null) {
                          var sigString = result.result;
                          return resolve(ContractUtil.getEthSig(sigString));
                        }
                        console.log("There was an error", err);
                        return reject(err);
                      }));
                
              }));
}

export {
  createPermitSig ,
  
}
/* ContractUtil Not a pure module */
